module.exports = __webpack_public_path__ + "img/kuaixun_bg_1.2a3d2717.png";